var constants = require('../constants');

const initialState = {
    type: null,
    props: {}
};

var modal = function(state, action) {
    var newState = Object.assign({}, state);
    switch (action.type) {
        case constants.SHOW_MODAL:
            newState.type = action.payload.type;
            newState.props = action.payload.props || initialState.props
            return newState;
        case constants.HIDE_MODAL:
            return initialState;
        default:
            return state || initialState;
    }
}

module.exports = modal;



// WEBPACK FOOTER //
// ./src/common/modules/modals/reducers/modal.js